import {
  Menu,
  SubMenuLink,
} from '@globalonmedia/ui-components/dist/types/components/header/menu.types'

const popularAssets: SubMenuLink[] = [
  {
    title: 'EUR-USD',
    href: '/currencies/eur/usd',
  },
  {
    title: 'USD-JPY',
    href: '/currencies/usd/jpy',
  },
  {
    title: 'GBP-USD',
    href: '/currencies/gbp/usd',
  },
  {
    title: 'USD-CHF',
    href: '/currencies/usd/chf',
  },
  {
    title: 'USD-CAD',
    href: '/currencies/usd/cad',
  },
  {
    title: 'AUD-USD',
    href: '/currencies/aud/usd',
  },
  {
    title: 'Bitcoin-USD',
    href: '/currencies/btc/usd',
  },
  {
    title: 'Gold',
    href: '/commodities/gold',
  },
  {
    title: 'Oil',
    href: '/commodities/crude-oil',
  },
  {
    title: 'All Currencies',
    href: '/currencies',
  },
  {
    title: 'All Commodities',
    href: '/commodities',
  },
  {
    title: 'All Indices',
    href: '/indices',
  },
]

const technicalAnalysis: SubMenuLink[] = [
  {
    title: 'weekly forex forecast',
    href: '/forex-technical-analysis/weekly-forex-forecast/page-1',
  },
  {
    title: 'free forex signals',
    href: '/forex-technical-analysis/free-forex-signals/page-1',
  },
  {
    title: 'gold price forecast',
    href: '/forex-technical-analysis/gold-price-forecast/page-1',
  },
]

const marketNewsMore: SubMenuLink[] = [
  {
    title: 'forex expo',
    href: '/forex-expo/page-1',
  },
  {
    title: 'fundamental analysis',
    href: '/forex-fundamental-analysis/page-1',
  },
  {
    title: 'regulatory updates',
    href: '/forex-figures',
  },
]

const bestOf: SubMenuLink[] = [
  {
    title: 'top forex brokers 2020',
    href: '/forex-brokers-reviews/page-1',
  },
  {
    title: 'best cfd brokers',
    href: '/forex-brokers/cfd-trading-brokers-reviews',
  },
  {
    title: 'best gold trading brokers',
    href: '/forex-brokers/gold-brokers-reviews',
  },
  {
    title: 'best brokers with islamic accounts',
    href: '/forex-brokers/islamic-forex-brokers-reviews',
  },
  {
    title: 'best ecn brokers',
    href: '/forex-brokers/ecn-brokers',
  },
  {
    title: 'best bitcoin brokers',
    href: '/forex-brokers/bitcoin-brokers',
  },
  {
    title: 'regulated forex brokers',
    href: '/forex-brokers/regulated-forex-brokers-reviews',
  },
]

const forexReviewsBestBtTradingPlatform: SubMenuLink[] = [
  {
    title: 'automated forex trading',
    href: '/automated-forex-trading/page-1',
  },
  {
    title: 'copy trading platforms',
    href: '/forex-brokers/copy-trading-platforms',
  },
  {
    title: 'ctrader',
    href: '/forex-brokers/ctrader-forex-brokers-reviews',
  },
  {
    title: 'mt4 forex brokers',
    href: '/forex-brokers/mt4-forex-brokers-reviews',
  },
  {
    title: 'social trading platforms',
    href: '/forex-brokers/social-trading-platforms',
  },
  {
    title: 'web based',
    href: '/forex-brokers/web-based-brokers-reviews',
  },
]

const bestBrokersByCountry: SubMenuLink[] = [
  {
    title: 'best us forex brokers',
    href: '/forex-brokers/us-forex-brokers',
  },
  {
    title: 'best asian forex brokers',
    href: '/forex-brokers/asia-forex-brokers',
  },
  {
    title: 'best brokers in canada',
    href: '/forex-brokers/forex-brokers-in-canada',
  },
  {
    title: 'best brokers in south africa',
    href: '/forex-brokers/south-africa-forex-brokers-reviews',
  },
  {
    title: 'best uk forex brokers',
    href: '/forex-brokers/uk-forex-brokers-reviews',
  },
  {
    title: 'best forex brokers in australia',
    href: '/forex-brokers/australia-forex-brokers',
  },
]

const getAdvice: SubMenuLink[] = [
  {
    title: 'compare online brokers',
    href: '#',
  },
  {
    title: 'how to choose a broker',
    href: '/learn/how-to-choose-a-broker-guide',
  },
  {
    title: 'help me choose a broker',
    href: '/suggest-forex-brokers',
  },
]

const guides: SubMenuLink[] = [
  {
    title: 'how to choose a broker',
    href: '/learn/how-to-choose-a-broker-guide',
  },
  {
    title: 'trading the trend lines',
    href: '/learn/trading-the-trend-lines-guide',
  },
  {
    title: 'forex social trading',
    href: '/learn/forex-social-trading',
  },
]

const learnToTradeBestBtTradingPlatform: SubMenuLink[] = [
  {
    title: 'jump start your forex trading',
    href: 'https://offers.dailyforex.com/lp2/ebooks/jump-start-your-forex-trading/',
  },
  {
    title: 'jproven trading strategies',
    href: 'https://offers.dailyforex.com/lp2/ebooks/tested-trend-strategy/',
  },
]

const learnToTradeMore: SubMenuLink[] = [
  {
    title: 'forex articles',
    href: '/forex-articles/page-1',
  },
  {
    title: 'forex webinars',
    href: '/forex-webinars/page-1',
  },
  {
    title: 'forex regulations',
    href: '/forex-brokers/regulation',
  },
  {
    title: 'forex basics',
    href: '/forex-basics',
  },
  {
    title: 'forex glossary',
    href: '/forex-glossary',
  },
]

const calendars: SubMenuLink[] = [
  {
    title: 'economic calendar',
    href: '#',
  },
  {
    title: 'holiday calendar',
    href: '#',
  },
]

const calculators: SubMenuLink[] = [
  {
    title: 'pivot point calculator',
    href: '#',
  },
  {
    title: 'profit calculator',
    href: '#',
  },
  {
    title: 'margin calculator',
    href: '#',
  },
  {
    title: 'currencies heat map',
    href: '#',
  },
]

const charts: SubMenuLink[] = [
  {
    title: 'live charts',
    href: '#',
  },
  {
    title: 'forex chart',
    href: '#',
  },
  {
    title: 'futures chart',
    href: '#',
  },
  {
    title: 'stocks chart',
    href: '#',
  },
  {
    title: 'indices chart',
    href: '#',
  },
  {
    title: 'cryptocurrency chart',
    href: '#',
  },
]

export const menu: Menu = {
  marketNews: {
    title: 'market news',
    popularAssets: {
      heading: 'popular assets',
      items: popularAssets,
    },
    technicalAnalysis: {
      heading: 'technical analysis',
      items: technicalAnalysis,
    },
    more: {
      heading: 'more',
      items: marketNewsMore,
    },
  },
  forexReviews: {
    title: 'forex reviews',
    bestOf: {
      heading: 'best of',
      items: bestOf,
    },
    bestBtTradingPlatform: {
      heading: 'best bt trading platform',
      items: forexReviewsBestBtTradingPlatform,
    },
    bestBrokersByCountry: {
      heading: 'best brokers by country',
      items: bestBrokersByCountry,
    },
    getAdvice: {
      heading: 'get advice',
      items: getAdvice,
    },
  },
  learnToTrade: {
    title: 'learn to trade',
    guides: {
      heading: 'guides',
      items: guides,
    },
    bestBtTradingPlatform: {
      heading: 'best bt trading platform',
      items: learnToTradeBestBtTradingPlatform,
    },
    more: {
      heading: 'more',
      items: learnToTradeMore,
    },
    learnForexAtFXAcademy: {
      heading: 'learn forex at fxacademy',
    },
  },
  tradingTools: {
    title: 'trading tools',
    calendars: {
      heading: 'calendars',
      items: calendars,
    },
    calculators: {
      heading: 'calculators',
      items: calculators,
    },
    charts: {
      heading: 'charts',
      items: charts,
    },
  },
}
